export default function(){var e={};return e.promise=new Promise((function(r,n){e.resolve=r,e.reject=n})),e}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amap/amap-vue/es/utils/defer.js
// module id = null
// module chunks = 